import { Box, Button, Grid, Typography } from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import * as React from "react";
import { Role } from "../../../../helper";
import TitleTooltip from "../../../../sharedComponents/Tooltip/TitleTooltip";
import { useStyles } from "./UpdatePlayerDetails";
import {
  getDateInput,
  getDropDown,
  getInputBox,
} from "../../../../sharedComponents/formFields/LabelInFormFields";

const ResidenceComponent = ({
  formData,
  playerPOD,
  user,
  checkIfPlayerPODDisabled,
  handleOpenCloseCounterMmtUpload,
  handleOpenClosePHIDocumentUpload,
  handleInputChange,
  handlePODChange,
  dropDownData,
}) => {
  const classes = useStyles();

  return (
    <>
      <Box>
        <Typography
          noWrap
          variant="subtitle1"
          className={classes.firstSectionTitle}
        >
          Residence
        </Typography>
      </Box>
      <Grid
        container
        wrap="nowrap"
        spacing={1}
        // columns={3}
        sx={{ paddingTop: "27px" }}
      >
        <Grid item lg={4} md={4} sm={4} xs={4}>
          {getDropDown(
            "Country",
            formData.countryId,
            (e) => {
              handleInputChange(e, "countryId");
            },
            dropDownData.country
          )}
        </Grid>
        <Grid item lg={4} md={4} sm={4} xs={4} pl={2}>
          {formData.countryId === 1
            ? getDropDown(
                "State/Province",
                formData.stateId,
                (e) => {
                  handleInputChange(e, "stateId");
                },
                dropDownData.state
              )
            : getInputBox("State/Province", formData.state_Other, (e) => {
                handleInputChange(e, "state_Other");
              })}
        </Grid>
        <Grid item lg={4} md={4} sm={4} xs={4} pl={2}>
          {getInputBox("City", formData.address2, (e) => {
            handleInputChange(e, "address2");
          })}
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item lg={9.5} md={12} sm={12} xs={12}>
          {getInputBox("Address", formData.address1, (e) => {
            handleInputChange(e, "address1");
          })}
        </Grid>
        <Grid item lg={2.5} md={12} sm={12} xs={12}>
          {getInputBox("Zip Code", formData.zip, (e) => {
            handleInputChange(e, "zip");
          })}
        </Grid>
      </Grid>
      <Grid container spacing={1.5} mt={0.3}>
        <Grid item lg={7} md={12} sm={12} xs={12}>
          <Box
            sx={{
              display: "flex",
              columnGap: "10px",
            }}
          >
            <Typography
              noWrap
              variant="subtitle1"
              className={classes.firstSectionTitle}
              sx={{ width: "50%", marginTop: "5px" }}
            >
              Date of Birth
            </Typography>
            {getDateInput(
              "Date of Birth",
              formData.dob,
              (e) => {
                handleInputChange(e, "dob");
              },
              false,
              "year",
              ["year", "", "month", "day"],
              true,
              true
            )}
          </Box>
        </Grid>
        <Grid item lg={5} md={12} sm={12} xs={12} mt={-1}>
          {getDropDown(
            "Player POD",
            playerPOD.podNumber,
            handlePODChange,
            dropDownData.pod,
            checkIfPlayerPODDisabled(formData.participate)
          )}
        </Grid>
      </Grid>

      <Grid container spacing={1.5} mt={0.3}>
        {/* COUNTER MOVEMENT SECTION */}
        <Grid item xs={5}>
          <Box
            sx={{
              display: "flex",
              columnGap: "10px",
            }}
          >
            <Typography
              noWrap
              variant="subtitle1"
              className={classes.firstSectionTitle}
            >
              Upload Counter Movements
            </Typography>
            <Button
              sx={{
                textTransform: "none",
                padding: "2px 2px",
                marginRight: "5px",
                cursor: "pointer",
                minWidth: "20px !important",
              }}
              size="small"
              variant="contained"
              title="Upload"
              onClick={() => {
                handleOpenCloseCounterMmtUpload(true);
              }}
            >
              <TitleTooltip title="Upload Counter Movements">
                <UploadIcon />
              </TitleTooltip>
            </Button>
          </Box>
        </Grid>

        {/* DEXABODY FAT DOC UPLOAD SECTION */}
        {user.appRoles?.includes(Role.Admin) && (
          <Grid item xs={5}>
            <Box
              sx={{
                display: "flex",
                columnGap: "10px",
              }}
            >
              <Typography
                noWrap
                variant="subtitle1"
                className={classes.firstSectionTitle}
              >
                Upload PHI Documents
              </Typography>
              <Button
                sx={{
                  textTransform: "none",
                  padding: "2px 2px",
                  marginRight: "5px",
                  cursor: "pointer",
                  minWidth: "20px !important",
                }}
                size="small"
                variant="contained"
                title="Upload"
                onClick={() => {
                  handleOpenClosePHIDocumentUpload(true);
                }}
              >
                <TitleTooltip title="Upload PHI document">
                  <UploadFileIcon />
                </TitleTooltip>
              </Button>
            </Box>
          </Grid>
        )}
      </Grid>
    </>
  );
};
export default React.memo(ResidenceComponent);
